import { ENABLE_MARKETPLACE_BRIEF_AUDIT_CHANGES } from '@utils/constants';
import { useExperiments } from '@wix/fe-essentials-standalone';

export const useMarketplaceBriefAuditChanges = () => {
  const { experiments } = useExperiments({ readOnly: true });
  const isAuditChangeEnabled = experiments.enabled(
    ENABLE_MARKETPLACE_BRIEF_AUDIT_CHANGES,
  );

  return { isAuditChangeEnabled };
};
